/* eslint-disable max-lines */
import { Reducer } from 'redux'

import {
  LOGOUT_ACTION,
  logoutPlainAction,
} from 'actions/authorization/logoutAction'
import {
  ChatMessengerActionTypes,
  FORCE_REPLACE_MESSAGES,
  MARK_ALL_READ,
  MARK_READ_MESSAGE_CURRENT_CHAT,
  SEND_PHOTOS,
  SUPPORT_OPEN_TICKET,
  TOGGLE_DEFERRED_MARK_ALL_READED,
  TOGGLE_FORCE_REFETCH,
  TOGGLE_NEW_INCOMING,
  UPDATE_PHOTO_IN_MESSAGE,
  UPDATE_CHAT_MESSENGER_SELECTED_PROFILE,
  CLEAR_PHOTO_IN_MESSAGE,
} from 'actions/chatMessengerAction'
import {
  UPDATE_CONTACTS_STATUS,
  ContactsUpdateActionTypes,
} from 'actions/contactList/contactsUpdateAction'
import {
  OpenEmojiPickerAction,
  TOGGLE_EMOJI_PICKER,
} from 'actions/emoji/openEmojiPickerAction'
import {
  CHAT_MESSAGE_PHOTO_LOAD_STATUS,
  CHAT_MESSAGE_RESET_PHOTO_LOAD_STATUS,
  ChatMessengerPhotoTypes,
} from 'actions/messenger/chatMessengerPhotoAction'
import {
  ChatMessengerSupportTypes,
  SUPPORT_OPEN_TICKET_TOGGLE,
} from 'actions/messenger/chatSupportOpenTicketAction'
import {
  ChatMessengerFetchTypes,
  FETCH_MESSENGER_CHAT,
} from 'actions/messenger/fetchMessengerChatAction'
import {
  fetchOutsideContactsPlainAction,
  FETCH_OUTSIDE_CONTACTS,
} from 'actions/messenger/fetchOutsideContactsAction'
import { MessengerEditActionTypes } from 'actions/messenger/messengerEditAction'
import {
  MessengerScrollActionTypes,
  SET_MESSENGER_SCROLL_BOTTOM,
} from 'actions/messenger/messengerScrollAction'
import {
  MessengerTextActionTypes,
  SET_MESSENGER_INPUT_VALUE_ACTION,
} from 'actions/messenger/messengerTextActions'
import { RESET_TYPING } from 'actions/messenger/resetTypingAction'
import {
  SendFailedMessageAction,
  SEND_FAILED_MESSAGE,
} from 'actions/messenger/sendFailedMessageAction'
import { SEND_MESSAGE } from 'actions/messenger/sendMessageAction'
import {
  sendOutsideContactPlainAction,
  SEND_OUTSIDE_CONTACT,
} from 'actions/messenger/sendOutsideContactAction'
import {
  toggleOpenContactsPlainAction,
  TOGGLE_OPEN_CONTACTS,
} from 'actions/messenger/toggleOpenContactsAction'
import {
  updateEditMessageIdAction,
  UPDATE_EDIT_MESSAGE_ID_ACTION,
} from 'actions/messenger/updateEditMessageIdAction'
import {
  updateNavigateToMessageIdAction,
  UPDATE_NAVIGATE_TO_MESSAGE_ID,
} from 'actions/messenger/updateNavigateToMessageIdAction'
import {
  updateOutsideContactAction,
  UPDATE_OUTSIDE_CONTACT,
} from 'actions/messenger/updateOutsideContactAction'
import {
  updateReplyMessageIdAction,
  UPDATE_REPLY_MESSAGE_ID,
} from 'actions/messenger/updateReplyMessageIdAction'
import {
  addReactionAction,
  ADD_REACTION,
} from 'actions/messengerReactions/addReactionAction'
import {
  fetchReactionListAction,
  FETCH_REACTION_LIST,
} from 'actions/messengerReactions/fetchReactionListAction'
import {
  readReactionAction,
  READ_REACTION,
} from 'actions/messengerReactions/readReactionAction'
import {
  removeReactionAction,
  REMOVE_REACTION,
} from 'actions/messengerReactions/removeReactionAction'
import {
  updateReactionAction,
  UPDATE_REACTION,
} from 'actions/messengerReactions/updateReactionAction'
import {
  MUTE_PROFILE,
  ToggleMuteTypes,
  UNMUTE_PROFILE,
} from 'actions/mute/toggleMuteAction'
import {
  PHOTOS_ATTACH_DELETE,
  PhotosAttachType,
} from 'actions/photo/photosAlbumAttachAction'
import {
  SOCKET_RECEIVE_DATA,
  SocketReceiveDataTypes,
} from 'actions/socket/socketReceiveDataAction'
import { LoadStatus } from 'api/LoadStatus'
import { prepareMessagesStructure } from 'components/page/Chat/Messenger/Messenger.functions'
import { isServerError } from 'functions/api/isServerError'
import { createTypingMessageUserChannel } from 'functions/comet'
import { defaultPromiseReducer } from 'reducers/defaultPromiseReducer'
import {
  ChatData,
  ChatMessengerState,
  initialState,
} from 'reducers/messenger/ChatMessengerState'
import { updateMessengerFromWebSocket } from 'reducers/messenger/function/updateMessengerFromWebSocket'
import {
  addToArrayPhoto,
  checkIsSupportChat,
  createFailedMessage,
  handleMessagesProgressiveLoading,
  markAllMessagesAsReaded,
  updateMessagesWithAddedReaction,
  updateMessagesWithReadReaction,
  updateMessagesWithRemovedReaction,
  updateMessagesWithReplacedReaction,
} from 'reducers/messenger/messenger.functions'

export const chatMessengerReducer: Reducer<
  ChatMessengerState,
  | ChatMessengerPhotoTypes
  | MessengerScrollActionTypes
  | ChatMessengerFetchTypes
  | MessengerEditActionTypes
  | MessengerTextActionTypes
  | SocketReceiveDataTypes
  | ChatMessengerSupportTypes
  | PhotosAttachType
  | ChatMessengerActionTypes
  | ContactsUpdateActionTypes
  | OpenEmojiPickerAction
  | ReturnType<typeof toggleOpenContactsPlainAction>
  | ReturnType<typeof fetchOutsideContactsPlainAction>
  | ReturnType<typeof updateOutsideContactAction>
  | ReturnType<typeof sendOutsideContactPlainAction>
  | ReturnType<typeof updateReplyMessageIdAction>
  | ReturnType<typeof updateNavigateToMessageIdAction>
  | ReturnType<typeof updateEditMessageIdAction>
  | SendFailedMessageAction
  | ToggleMuteTypes
  | ReturnType<typeof fetchReactionListAction>
  | ReturnType<typeof addReactionAction>
  | ReturnType<typeof updateReactionAction>
  | ReturnType<typeof removeReactionAction>
  | ReturnType<typeof readReactionAction>
  | ReturnType<typeof logoutPlainAction>
> = (state = initialState, action): ChatMessengerState => {
  switch (action.type) {
    case FETCH_MESSENGER_CHAT:
      return defaultPromiseReducer(
        state,
        action,
        () => {
          return {
            loadingChat: true,
            loadedChat: false,
            chatFetchingServerError: false,
            chatData: action.isChangedProfileId
              ? ({
                  anketa: {
                    isBot: false,
                  },
                } as unknown as ChatData)
              : state.chatData,
            isChangedProfileId:
              action.isChangedProfileId || state.isChangedProfileId,
            isSupport: checkIsSupportChat(Number(action.profileId)),
            statusRequestChat: action.isChangedProfileId
              ? LoadStatus.loading
              : state.statusRequestChat,
            editMessageId: null,
          }
        },
        (result) => {
          const _updatedMessages = handleMessagesProgressiveLoading(
            result?.messages,
            state.messages,
            action.loadMoreOld,
            action.loadMoreNew
          )

          // Для заблокированного приходит isIncoming, для незаблокированного incoming
          const updatedMessages = _updatedMessages.map((item) => {
            if ('isIncoming' in item) {
              const { isIncoming, ...rest } = item
              return { ...rest, incoming: isIncoming as boolean }
            }
            return item
          })

          return {
            messages: updatedMessages,
            messagesByDays: prepareMessagesStructure(updatedMessages),
            chatData: result?.recipient || {},
            loadingChat: false,
            loadedChat: true,
            chatFetchingServerError: false,
            firstLoadFinished: true,
            isChangedProfileId: false,
            isEndOfMessages:
              result?.messages === undefined ||
              result.messages.length < action.limit,
            statusRequestChat: LoadStatus.loaded,
            messagesImageList: updatedMessages
              .filter(({ options }) => options && options.photoUrl)
              .map(({ id }) => id)
              .reduce((acc, id) => ({ ...acc, [id]: false }), {}),
            needScrollBottom: action.isChangedProfileId,
            photosRestrictionStatus: result.photosRestrictionStatus,
            requestStatus: result.requestStatus!,
            isSupport: checkIsSupportChat(Number(action.profileId)),
          }
        },
        (_result, _state, _error, errorStatus) => {
          return {
            loadingChat: false,
            loadedChat: false,
            chatFetchingServerError: isServerError(errorStatus),
            isChangedProfileId: false,
            statusRequestChat: LoadStatus.loaded,
          }
        }
      )

    case FORCE_REPLACE_MESSAGES:
      return {
        ...state,
        messages: action.payload.messages,
        messagesByDays: prepareMessagesStructure(action.payload.messages),
      }

    case TOGGLE_NEW_INCOMING:
      return {
        ...state,
        hasNewMessages: action.value,
      }

    case RESET_TYPING:
      return {
        ...state,
        isTyping: false,
        typingUser: 0,
      }

    case MARK_ALL_READ:
      const updatedMessages = markAllMessagesAsReaded([...state.messages])

      return {
        ...state,
        messages: updatedMessages,
        messagesByDays: prepareMessagesStructure(updatedMessages),
      }

    case SOCKET_RECEIVE_DATA:
      const { result: socketResult, userId, chatSelectedProfileId } = action

      if (
        state.statusRequestChat === LoadStatus.loaded ||
        /**
         * Везде хотим видеть, что печатает контакт.
         */
        socketResult[0].channel ===
          createTypingMessageUserChannel(action.userId)
      ) {
        return updateMessengerFromWebSocket(
          userId,
          state,
          socketResult,
          chatSelectedProfileId
        )
      } else {
        console.warn(
          'Wrong request status chat',
          state.statusRequestChat,
          socketResult
        )
      }

      return state

    case TOGGLE_DEFERRED_MARK_ALL_READED:
      return {
        ...state,
        deferredMarkAllReaded: action.payload.value,
      }

    case TOGGLE_FORCE_REFETCH:
      return {
        ...state,
        forceRefetch: action.payload.value,
      }

    case UPDATE_PHOTO_IN_MESSAGE:
      return {
        ...state,
        photosSelected: addToArrayPhoto(
          state.photosSelected,
          action.result.photo
        ),
      }

    case CLEAR_PHOTO_IN_MESSAGE:
      return {
        ...state,
        photosSelected: [],
      }

    case SEND_PHOTOS:
    case PHOTOS_ATTACH_DELETE:
      return defaultPromiseReducer(state, action, undefined, () => ({
        photosSelected: [],
      }))

    case SET_MESSENGER_INPUT_VALUE_ACTION:
      return {
        ...state,
        contentInput: action.contentInput,
      }

    case CHAT_MESSAGE_PHOTO_LOAD_STATUS:
      return {
        ...state,
        messagesImageList: {
          ...state.messagesImageList,
          [action.messageId]: action.loaded,
        },
      }

    case CHAT_MESSAGE_RESET_PHOTO_LOAD_STATUS:
      return {
        ...state,
        messagesImageList: {},
      }

    case SEND_MESSAGE:
      return defaultPromiseReducer(
        state,
        action,
        () => ({
          messageSending: true,
        }),
        () => ({
          messageSending: false,
          replyMessageId: null,
          editMessageId: null,
        }),
        () => {
          const updateMessagesList = [
            createFailedMessage(state, action.message),
            ...state.messages,
          ]
          return {
            messageSending: false,
            messages: updateMessagesList,
            messagesByDays: prepareMessagesStructure(updateMessagesList),
            replyMessageId: null,
          }
        }
      )

    case SEND_FAILED_MESSAGE:
      return defaultPromiseReducer(
        state,
        action,
        () => ({
          messageSending: true,
        }),
        () => {
          const updateMessagesList = state.messages.filter(
            ({ id }) => id !== action.messageId
          )
          return {
            messageSending: false,
            messages: updateMessagesList,
            messagesByDays: prepareMessagesStructure(updateMessagesList),
          }
        },
        () => ({
          messageSending: false,
        })
      )

    case SET_MESSENGER_SCROLL_BOTTOM:
      return {
        ...state,
        needScrollBottom: action.value,
      }

    case MARK_READ_MESSAGE_CURRENT_CHAT:
      return defaultPromiseReducer(state, action, undefined, () => ({
        updateReadedByContactId: 0,
      }))

    case UPDATE_CONTACTS_STATUS:
      return defaultPromiseReducer(
        state,
        action,
        () => ({
          updateContactsProgress: true,
        }),
        () => ({
          updateContacts: false,
          updateContactsProgress: false,
        })
      )

    case SUPPORT_OPEN_TICKET_TOGGLE:
      return {
        ...state,
        openSupportTicket: true,
      }

    case SUPPORT_OPEN_TICKET:
      return defaultPromiseReducer(state, action, undefined, () => ({
        openSupportTicket: false,
      }))

    case UPDATE_CHAT_MESSENGER_SELECTED_PROFILE:
      return { ...state, selectedProfileId: action.profileId }

    case TOGGLE_OPEN_CONTACTS:
      return {
        ...state,
        contactsOpened: action.contactsOpened,
        replyMessageId: null,
        editMessageId: null,
      }

    case TOGGLE_EMOJI_PICKER: {
      return {
        ...state,
        contactsOpened: null,
        replyMessageId: null,
        editMessageId: null,
      }
    }

    case FETCH_OUTSIDE_CONTACTS:
      return defaultPromiseReducer(
        state,
        action,
        () => ({
          outsideContactsFetching: true,
          outsideContactsFetched: false,
          outsideContactsFetchingFailed: false,
        }),
        (result) => ({
          outsideContactsFetching: false,
          outsideContactsFetched: true,
          outsideContactsFetchingFailed: false,
          outsideContacts: result,
          outsideContactsRequested: true,
        }),
        () => ({
          outsideContactsFetching: false,
          outsideContactsFetched: false,
          outsideContactsFetchingFailed: true,
          outsideContactsRequested: true,
        })
      )

    case UPDATE_OUTSIDE_CONTACT:
      return defaultPromiseReducer(
        state,
        action,
        () => ({
          outsideContactUpdating: true,
          outsideContactUpdated: false,
          outsideContactUpdatingFailed: false,
        }),
        () => ({
          outsideContactUpdating: false,
          outsideContactUpdated: true,
          outsideContactUpdatingFailed: false,
        }),
        () => ({
          outsideContactUpdating: false,
          outsideContactUpdated: false,
          outsideContactUpdatingFailed: true,
        })
      )

    case SEND_OUTSIDE_CONTACT:
      return defaultPromiseReducer(
        state,
        action,
        () => ({
          outsideContactSending: true,
          outsideContactSendingFailed: false,
        }),
        () => ({
          outsideContactSending: false,
          outsideContactSendingFailed: false,
        }),
        () => ({
          outsideContactSending: false,
          outsideContactSendingFailed: true,
        })
      )

    case UPDATE_REPLY_MESSAGE_ID:
      return {
        ...state,
        replyMessageId: action.messageId,
        editMessageId: null,
      }

    case UPDATE_NAVIGATE_TO_MESSAGE_ID:
      return {
        ...state,
        navigateToMessageId: action.navigateToMessageId,
      }

    case UPDATE_EDIT_MESSAGE_ID_ACTION:
      return {
        ...state,
        replyMessageId: null,
        contactsOpened: false,
        editMessageId: action.messageId,
      }

    case MUTE_PROFILE:
    case UNMUTE_PROFILE:
      return defaultPromiseReducer(state, action, undefined, () => ({
        chatData: {
          ...state.chatData,
          isMutedByMe: !state.chatData.isMutedByMe,
        },
      }))

    case FETCH_REACTION_LIST:
      return defaultPromiseReducer(state, action, undefined, (result) => ({
        reactions: result.reactions,
      }))

    case ADD_REACTION:
      return defaultPromiseReducer(state, action, () =>
        updateMessagesWithAddedReaction(state, {
          messageUuid: action.messageUuid,
          id: action.reaction.id,
          type: action.reaction.type,
          userId: action.profileId,
          value: action.reaction.value,
          createdAt: Math.round(Date.now() / 1000), // Секунды
        })
      )

    case UPDATE_REACTION:
      return defaultPromiseReducer(state, action, () =>
        updateMessagesWithReplacedReaction(state, {
          messageUuid: action.messageUuid,
          oldId: action.oldReaction.id,
          id: action.newReaction.id,
          type: action.newReaction.type,
          userId: action.profileId,
          value: action.newReaction.value,
          createdAt: Math.round(Date.now() / 1000), // Секунды
        })
      )

    case REMOVE_REACTION:
      return defaultPromiseReducer(state, action, () =>
        updateMessagesWithRemovedReaction(state, {
          messageUuid: action.messageUuid,
          id: action.reaction.id,
          userId: action.profileId,
        })
      )

    case READ_REACTION:
      return defaultPromiseReducer(state, action, undefined, () =>
        updateMessagesWithReadReaction(state, {
          messageUuid: action.messageUuid,
          id: action.reaction.id,
          userId: action.profileId,
          readAt: action.readAt,
        })
      )

    case LOGOUT_ACTION:
      return defaultPromiseReducer(state, action, undefined, () => ({
        ...initialState,
      }))

    default:
      return state
  }
}
